import React, { memo, useState } from 'react';
import SVG from 'react-inlinesvg';
import { Link, useRouteMatch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Collapse } from '@material-ui/core';
import styles from '../SideBar/sideBar.module.scss';
import { angleDownSVG, angleUpSVG } from '../../../shared/helpers/icons';
import { hasRouteAccess } from '../../helpers/loggedUser';

const SideBarItem = ({ route, action, locationPathName, loggedUser }) => {
    const { t } = useTranslation('home');

    const matchRoute = useRouteMatch(locationPathName);

    const [expanded, setExpanded] = useState(false);

    const hasAccess = route.isGroup ? true : hasRouteAccess(loggedUser, route.path);

    const isActiveItem = path => {
        if (matchRoute.path.includes(path) || String(path).includes(matchRoute.path)) {
            return styles.active;
        }
        if (route.isGroup && route.innerRoutes?.some(child =>
            locationPathName.startsWith(child.path.replace(/\/$/, ''))
        )) {
            return styles.active;
        }
        return "";
    }

    const handleExpandClick = e => setExpanded(!expanded);
    const handleAction = (route, fatherRoute) => {
        if (fatherRoute !== null) {
            route.routeTitle = {
                title: fatherRoute.title.key,
                childTitle: route.title.key
            };
        }

        action(route);
    };

    if (!route.availableSubMenu) {
        // If user doesn't have access, render as disabled div instead of Link
        if (!hasAccess) {
            return (
                <div className={`${styles.itemsContent} ${styles.disabled}`} key={route.path}>
                    <div
                        className={`
                            ${styles.item}
                            ${styles.click}
                        `}
                    >
                        <div className={`${styles.icon} ${styles.min}`}>
                            <SVG src={route.icon}></SVG>
                        </div>
                        <div className={styles.title}>{t(route.title.key)}</div>
                    </div>
                </div>
            );
        }

        return (
            <Link to={route.path} key={route.path} onClick={handleAction.bind(this, route, null)}>
                <div className={styles.itemsContent}>
                    <div
                        className={`
                            ${styles.item}
                            ${styles.click} ${
                            isActiveItem(route.path)}
                        `}
                    >
                        <div className={`${styles.icon} ${styles.min}`}>
                            <SVG src={route.icon}></SVG>
                        </div>
                        <div className={styles.title}>{t(route.title.key)}</div>
                    </div>
                </div>
            </Link>
        );
    } else {
        // For submenu items, disable if user doesn't have access
        return (
            <div key={route.path} className={`${styles.itemsContent} ${!hasAccess ? styles.disabled : ''}`}>
                <div
                    onClick={hasAccess ? handleExpandClick : undefined}
                    className={`
                        ${styles.item}
                        ${styles.clickCollapse}
                        ${isActiveItem(route.path)}
                    `}
                >
                    <div className={`${styles.icon} ${styles.min}`}>
                        <SVG src={route.icon}></SVG>
                    </div>
                    <div className={styles.title}>
                        <span>{t(route.title.key)}</span>
                        <div>
                            {!expanded && <SVG src={angleDownSVG} />}
                            {expanded && <SVG src={angleUpSVG} />}
                        </div>
                    </div>
                </div>
                {hasAccess && (
                    <Collapse in={expanded} timeout="auto" className={styles.collapse} unmountOnExit>
                        {route.innerRoutes.map((childRoute, x) => {
                            return (
                                <Link
                                    to={childRoute.path}
                                    key={`child-${childRoute.path}-${x}`}
                                    onClick={handleAction.bind(this, childRoute, route)}
                                >
                                    <div className={styles.itemsContent}>
                                        <div
                                            className={`
                                                ${styles.item}
                                                ${styles.subMenu}
                                                ${styles.click}
                                                ${locationPathName.startsWith(childRoute.path.replace(/\/$/, '')) ? styles.active : ''}
                                            `}
                                        >
                                            <div className={`${styles.subMenuicon} ${styles.min}`}>
                                                <SVG src={childRoute.icon}></SVG>
                                            </div>
                                            <div className={styles.title}>{t(childRoute.title.key)}</div>
                                        </div>
                                    </div>
                                </Link>
                            );
                        })}
                    </Collapse>
                )}
            </div>
        );
    }
};

export default memo(SideBarItem);
